// import React, { useState } from "react";
// import { Helmet } from "react-helmet";
// import { useFormik } from "formik";
// import { Col, Row } from "reactstrap";

// import { PageTitles } from "../../constants";
// import { SummaryCard } from "../../components/SummaryCard";
// import PDFUploader from "./PDFUpload";
// import CorporateWebForm from "./CorporateWebForm";
// import { LABLES, NAMES, PLACEHOLDERS } from "./WebFormFieldsNames";
// import { TextInput } from "../../components/Input";
// import FormikErrorText from "../../components/FormikErrorText/FormikErrorText";
// import validationSchema from "./FormValidations";
// import AutoComplete from "../../components/AutoComplete/AutoComplete";
// import { customStyles } from "./CustomStyles";
// import { data } from "./AutocompleteData";

// const WebForm = () => {
//     const [pdf, setPDF] = useState(null);
//     let { PDF_TITLE, COUNTRY, STATE, DIRECTORS } = LABLES;

//     const defaultFormData = {
//         [NAMES[PDF_TITLE]]: "",
//         [NAMES[COUNTRY]]: null,
//         [NAMES[STATE]]: null,
//         [NAMES[DIRECTORS]]: null
//     };
//     const formik = useFormik({
//         initialValues: { ...defaultFormData },
//         enableReinitialize: true,
//         validationSchema: validationSchema,
//         onSubmit: (values) => {}
//     });

//     // Country options
//     const countryOptions = data.map((item) => ({
//         label: item.name.charAt(0).toUpperCase() + item.name.slice(1),
//         value: item.name
//     }));

//     // Generate the numbers from 1 to 15 with leading zeros
//     const directorOptions = Array.from({ length: 15 }, (_, index) => ({
//         label: (index + 1).toString().padStart(2, "0"), // Formatting the number with leading zeros
//         value: (index + 1).toString().padStart(2, "0")
//     }));

//     const handleSetContentPDF = (pdfData) => {
//         console.log("Uploaded PDF Data: ", pdfData);
//     };

//     return (
//         <div className="my-1">
//             <Helmet>
//                 <title>{PageTitles.WEB_FORM}</title>
//             </Helmet>
//             <SummaryCard cardClass={"mt-2 pb-4"}>
//                 <Row className="p-2 mt-2">
//                     <Col sm="12" md="3" lg="3">
//                         <TextInput
//                             placeholder={PLACEHOLDERS[PDF_TITLE]}
//                             label={PDF_TITLE}
//                             name={NAMES[PDF_TITLE]}
//                             type={NAMES[PDF_TITLE]}
//                             onChange={formik.handleChange}
//                             onBlur={formik.handleBlur}
//                             value={formik.values[NAMES[PDF_TITLE]]}
//                             labelClass="custom-label mb-0"
//                             className="hide-default-icon text-input"
//                             autoFocus
//                         />

//                         <FormikErrorText
//                             formikInstance={formik}
//                             fieldName={NAMES[PDF_TITLE]}
//                             className="error"
//                         />
//                     </Col>

//                     <Col sm="12" md="3" lg="3">
//                         <AutoComplete
//                             label={COUNTRY}
//                             classNamePrefix="status-header-search-admin"
//                             labelClasses="auto-complete-label-class"
//                             customStyles={customStyles.statusFilter}
//                             options={countryOptions}
//                             value={countryOptions.find(
//                                 (option) => option.value === formik.values[NAMES[COUNTRY]]
//                             )}
//                             onChange={(option) => {
//                                 formik.setFieldValue(NAMES[COUNTRY], option?.value || null);
//                                 formik.setFieldValue(NAMES[STATE], null); // Reset state on country change
//                             }}
//                             placeholder={PLACEHOLDERS[COUNTRY]}
//                             maxMenuHeight={220}
//                             isClearable
//                         />
//                         <FormikErrorText
//                             formikInstance={formik}
//                             fieldName={NAMES[COUNTRY]}
//                             className="error"
//                         />
//                     </Col>

//                     <Col sm="12" md="3" lg="3">
//                         <AutoComplete
//                             label={STATE}
//                             labelClasses="auto-complete-label-class"
//                             classNamePrefix="status-header-search-admin"
//                             customStyles={customStyles.statusFilter}
//                             options={
//                                 data.find((item) => item.name === formik.values[NAMES[COUNTRY]])
//                                     ?.options || []
//                             }
//                             value={
//                                 (
//                                     data.find((item) => item.name === formik.values[NAMES[COUNTRY]])
//                                         ?.options || []
//                                 ).find((option) => option.value === formik.values[NAMES[STATE]]) ||
//                                 null
//                             }
//                             onChange={(option) =>
//                                 formik.setFieldValue(NAMES[STATE], option?.value || null)
//                             }
//                             placeholder={PLACEHOLDERS[STATE]}
//                             isClearable
//                             maxMenuHeight={220}
//                         />
//                         <FormikErrorText
//                             formikInstance={formik}
//                             fieldName={NAMES[STATE]}
//                             className="error"
//                         />
//                     </Col>

//                     <Col sm="12" md="3" lg="3">
//                         <AutoComplete
//                             label="Directors"
//                             labelClasses="auto-complete-label-class"
//                             customStyles={customStyles.statusFilter}
//                             value={directorOptions.find(
//                                 (option) => option.value == formik.values[NAMES[DIRECTORS]]
//                             )}
//                             onChange={(option) =>
//                                 formik.setFieldValue(NAMES[DIRECTORS], option?.value || null)
//                             }
//                             placeholder={PLACEHOLDERS[DIRECTORS]}
//                             classNamePrefix="status-header-search-admin"
//                             labelClass="custom-label mb-0"
//                             isClearable
//                             maxMenuHeight={220}
//                             options={directorOptions} // Pass the formatted options here
//                         />
//                         <FormikErrorText
//                             formikInstance={formik}
//                             fieldName={NAMES[DIRECTORS]}
//                             className="error"
//                         />
//                     </Col>
//                 </Row>
//             </SummaryCard>

//             <div>
//                 {/* {pdf ? ( */}
//                 {/* ) : ( */}
//                 <SummaryCard cardClass={"mt-4"}>
//                     <PDFUploader
//                         label="Upload Incorporation Document"
//                         labelClass="pdf-label p-2 mt-1"
//                         uploadText="Click here to upload your file or drag and drop."
//                         uploadSubText={"Supported Format: xlsx, xlsm, xlsb  "}
//                         setContentPDF={handleSetContentPDF}
//                         setPDF={setPDF}
//                     />
//                 </SummaryCard>
//                 {pdf ? <CorporateWebForm /> : null}

//                 {/* )} */}
//             </div>
//         </div>
//     );
// };
// export default WebForm;

import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useFormik } from "formik";
import { Col, Row } from "reactstrap";

import { PageTitles } from "../../constants";
import { SummaryCard } from "../../components/SummaryCard";
import PDFUploader from "./PDFUpload";
import CorporateWebForm from "./CorporateWebForm";
import { LABLES, NAMES, PLACEHOLDERS } from "./WebFormFieldsNames";
import { TextInput } from "../../components/Input";
import FormikErrorText from "../../components/FormikErrorText/FormikErrorText";
import validationSchema from "./FormValidations";
import AutoComplete from "../../components/AutoComplete/AutoComplete";
import { customStyles } from "./CustomStyles";
import { data } from "./AutocompleteData";

const WebForm = () => {
    const [pdf, setPDF] = useState(null); // Store uploaded PDF information
    const { PDF_TITLE, COUNTRY, STATE, DIRECTORS } = LABLES;

    // Initial form data
    const defaultFormData = {
        [NAMES[PDF_TITLE]]: "",
        [NAMES[COUNTRY]]: null,
        [NAMES[STATE]]: null,
        [NAMES[DIRECTORS]]: null
    };

    const formik = useFormik({
        initialValues: { ...defaultFormData },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            console.log("Form Submitted: ", values);
        }
    });

    // Country options
    const countryOptions = data.map((item) => ({
        label: item.name.charAt(0).toUpperCase() + item.name.slice(1),
        value: item.name
    }));

    // Generate director options
    const directorOptions = Array.from({ length: 15 }, (_, index) => ({
        label: (index + 1).toString().padStart(2, "0"), // Add leading zeros
        value: (index + 1).toString().padStart(2, "0")
    }));

    const handleSetContentPDF = (pdfData) => {
        console.log("Uploaded PDF Data: ", pdfData);
        setPDF(pdfData); // Set the uploaded PDF data
    };

    const handleSetPDF = (pdfData) => {
        console.log("Uploaded PDF data:", pdfData);
    };
    return (
        <div className="my-1">
            <Helmet>
                <title>{PageTitles.WEB_FORM}</title>
            </Helmet>

            {/* Form Fields */}
            <SummaryCard cardClass={"mt-2 pb-4"}>
                <Row className="p-2 mt-2">
                    <Col sm="12" md="3" lg="3">
                        <TextInput
                            placeholder={PLACEHOLDERS[PDF_TITLE]}
                            label={PDF_TITLE}
                            name={NAMES[PDF_TITLE]}
                            type="text"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values[NAMES[PDF_TITLE]]}
                            labelClass="custom-label mb-0"
                            className="hide-default-icon text-input"
                            autoFocus
                        />
                        <FormikErrorText
                            formikInstance={formik}
                            fieldName={NAMES[PDF_TITLE]}
                            className="error"
                        />
                    </Col>

                    <Col sm="12" md="3" lg="3">
                        <AutoComplete
                            label={COUNTRY}
                            classNamePrefix="status-header-search-admin"
                            labelClasses="auto-complete-label-class"
                            customStyles={customStyles.statusFilter}
                            options={countryOptions}
                            value={countryOptions.find(
                                (option) => option.value === formik.values[NAMES[COUNTRY]]
                            )}
                            onChange={(option) => {
                                formik.setFieldValue(NAMES[COUNTRY], option?.value || null);
                                formik.setFieldValue(NAMES[STATE], null); // Reset state
                            }}
                            placeholder={PLACEHOLDERS[COUNTRY]}
                            maxMenuHeight={220}
                            isClearable
                        />
                        <FormikErrorText
                            formikInstance={formik}
                            fieldName={NAMES[COUNTRY]}
                            className="error"
                        />
                    </Col>

                    <Col sm="12" md="3" lg="3">
                        <AutoComplete
                            label={STATE}
                            labelClasses="auto-complete-label-class"
                            classNamePrefix="status-header-search-admin"
                            customStyles={customStyles.statusFilter}
                            options={
                                data.find((item) => item.name === formik.values[NAMES[COUNTRY]])
                                    ?.options || []
                            }
                            value={
                                (
                                    data.find((item) => item.name === formik.values[NAMES[COUNTRY]])
                                        ?.options || []
                                ).find((option) => option.value === formik.values[NAMES[STATE]]) ||
                                null
                            }
                            onChange={(option) =>
                                formik.setFieldValue(NAMES[STATE], option?.value || null)
                            }
                            placeholder={PLACEHOLDERS[STATE]}
                            isClearable
                            maxMenuHeight={220}
                        />
                        <FormikErrorText
                            formikInstance={formik}
                            fieldName={NAMES[STATE]}
                            className="error"
                        />
                    </Col>

                    <Col sm="12" md="3" lg="3">
                        <AutoComplete
                            label={DIRECTORS}
                            labelClasses="auto-complete-label-class"
                            customStyles={customStyles.statusFilter}
                            value={directorOptions.find(
                                (option) => option.value === formik.values[NAMES[DIRECTORS]]
                            )}
                            onChange={(option) =>
                                formik.setFieldValue(NAMES[DIRECTORS], option?.value || null)
                            }
                            placeholder={PLACEHOLDERS[DIRECTORS]}
                            classNamePrefix="status-header-search-admin"
                            labelClass="custom-label mb-0"
                            isClearable
                            maxMenuHeight={220}
                            options={directorOptions}
                        />
                        <FormikErrorText
                            formikInstance={formik}
                            fieldName={NAMES[DIRECTORS]}
                            className="error"
                        />
                    </Col>
                </Row>
            </SummaryCard>

            {/* PDF Upload */}
            <SummaryCard cardClass={"mt-4"}>
                <PDFUploader
                    label="Upload Incorporation Document"
                    labelClass="pdf-label p-2 mt-1"
                    uploadText="Click here to upload your file or drag and drop."
                    uploadSubText="Supported Format: pdf, xlsx, xlsm, xlsb"
                    setContentPDF={handleSetContentPDF}
                    setPDF={handleSetPDF} // Add this line
                />
            </SummaryCard>

            {/* Render CorporateWebForm if PDF is uploaded */}
            {pdf && <CorporateWebForm />}
        </div>
    );
};

export default WebForm;
